import { useEffect } from 'react'
import './style.css'
import TopBar from '../../components/general/topbar/TopBar';
import Footer from '../../components/general/footer/Footer';
import MainTitle from '../../components/general/maintitle/MainTitle';
import Banner from '../../assets/images/banners/webps/equipostecnoref.webp'
import { Helmet } from 'react-helmet';

export default function Contact() {

  useEffect(() => {
    window.scroll(0,0);
  })
  
  const texto = 
    <>
<h3><strong>Consultas T&eacute;cnicas</strong></h3>
<p><strong>&nbsp;</strong></p>
<h4><u>&iquest;Qu&eacute; equipo necesito para transportar mi mercader&iacute;a?</u></h4>
<p>Dependiendo de las temperaturas que requiera la mercader&iacute;a que estas buscando transportar existen diferentes opciones.</p>
<ul>
<li>Hasta 0&deg;C</li>
</ul>
<p>Para transporte de productos tales como frutas, verduras y fiambres</p>
<ul>
<li>Hasta -5&deg;C</li>
</ul>
<p>Para transporte de productos tales como quesos, l&aacute;cteos y bebidas</p>
<ul>
<li>Hasta -25&deg;C</li>
</ul>
<p>Para transporte de productos tales como helado, hielo y congelados</p>
<p>Para una elecci&oacute;n de la mejor opci&oacute;n cont&aacute;ctate con nosotros</p>
<p>&nbsp;</p>
<h4><u>&iquest;El equipo de frio anula el aire acondicionado de mi veh&iacute;culo?</u></h4>
<p>En la mayor&iacute;a de las ocasiones el equipo de fr&iacute;o no anula el aire acondicionado del veh&iacute;culo, salvo el caso de algunos utilitarios peque&ntilde;os que no tengan la opci&oacute;n de poner un alternador m&aacute;s grande junto a una bater&iacute;a auxiliar.</p>
<p>&nbsp;</p>
<p>&nbsp;</p>
<h3><strong>Consultas de la aislaci&oacute;n</strong></h3>
<p><strong>&nbsp;</strong></p>
<h4><u>&iquest;El equipo viene con aislaci&oacute;n?</u></h4>
<p>Para el caso de utilitarios, el equipo se puede pedir con la aislaci&oacute;n correspondiente para el veh&iacute;culo.</p>
<p>Existen medidas estandarizadas para los siguientes veh&iacute;culos:</p>
<ul>
<li>Citro&euml;n Berlingo</li>
<li>Citro&euml;n Jumpy</li>
<li>Citro&euml;n Jumper</li>
<li>Fiat Fiorino</li>
<li>Fiat Ducato</li>
<li>Fiat Qubo</li>
<li>Ford Transit</li>
<li>Iveco Daily</li>
<li>Peugeot Partner</li>
<li>Peugeot Boxer</li>
<li>Peugeot Expert</li>
<li>Renault Kangoo</li>
<li>Renault Master</li>
<li>Mercedes Benz Vito</li>
<li>Mercedes Benz Sprinter</li>
</ul>
<p>Para saber si hay aislaciones disponibles para tu veh&iacute;culo, contacte con nosotros</p>
<p>&nbsp;</p>
<h4><u>&iquest;Se puede comprar solo la aislaci&oacute;n?</u></h4>
<p>No, &uacute;nicamente se puede comprar la aislaci&oacute;n en conjunto con el equipo.</p>
<p>&nbsp;</p>
<h4><u>&iquest;Cu&aacute;nto espacio me quita la aislaci&oacute;n?</u></h4>
<p>La aislaci&oacute;n no quita espacio utilizable en el veh&iacute;culo</p>
<p>Para m&aacute;s informaci&oacute;n pod&eacute;s contactarte con nosotros</p>
<p>&nbsp;</p>
<p>&nbsp;</p>
<h3><strong>Consultas Administrativas</strong></h3>
<p><strong>&nbsp;</strong></p>
<h4><u>&iquest;En cu&aacute;nto tiempo se realiza la entrega del equipo?</u></h4>
<p>El plazo de entrega se encuentra sujeto a los tiempos de producci&oacute;n de f&aacute;brica.</p>
<p>Generalmente se maneja un plazo de 30 d&iacute;as, pero agradecemos la consulta previa.</p>
<p>&nbsp;</p>
<h4><u>&iquest;Cu&aacute;nto dura la garant&iacute;a del equipo?</u></h4>
<p>El equipo posee garant&iacute;a completa de un a&ntilde;o.</p>
<p>&nbsp;</p>
<p>&nbsp;</p>
<h3><strong>Otras consultas</strong></h3>
<p>&nbsp;</p>
<h4><u>Ya tengo comprado un equipo de frio &iquest;Ustedes lo pueden instalar?</u></h4>
<p>Si la garant&iacute;a lo permite, no habr&iacute;a ning&uacute;n problema. Cont&aacute;ctate con nosotros para solicitar un turno.</p>
<p>&nbsp;</p>
<h4><u>Ya tengo hecha la aislaci&oacute;n en mi veh&iacute;culo &iquest;Puedo instalar solo el equipo?</u></h4>
<p>Se puede realizar la instalaci&oacute;n del equipo. Sin embargo, debemos aclarar que las pruebas de rendimiento y uso de los equipos est&aacute;n hechas con las aislaciones provistas por la f&aacute;brica.</p>
<p>Por lo tanto, en caso de utilizar otra diferente, no podemos garantizar el correcto rendimiento del equipo.</p>
<p>&nbsp;</p>
    </>

  const metaTags = {
    title: "Preguntas frecuentes sobre equipos de frío",
    description: "Desde nuestro área de servicios, nos dedicamos a la reparación y mantenimiento de equipos de frio para el transporte refrigerado (multimarca), para su flota",
    url: "https://www.nicolinirefrigeracion.com.ar/faq"
  }

  return (
    <div className='FAQ'>

      <Helmet>
        <title>{metaTags.title}</title>
        <meta name="description" 
        content={metaTags.description} />
        
        <meta property="og:site_name" content={metaTags.title} />
        <meta property="og:title" content={metaTags.title} />
        <meta property="og:description" content={metaTags.description} />
        <meta property="og:image" content={Banner} />
        <meta property="og:url" content={metaTags.url} />
        <meta property="og:type" content="website" />

        <meta name="twitter:title" content={metaTags.title} />
        <meta name="twitter:description" content={metaTags.description} />
        <meta name="twitter:image" content={Banner} />
      </Helmet>

      <TopBar />
      <div className='FAQDisplay'>
        <MainTitle text={"Preguntas Frecuentes"} />
        {texto}
      </div>
        
      <Footer />
    </div>
  )
}